import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';
import {
  DEVICE_LIST_TAB_PARAM,
  DeviceListTabCoCo,
  getDeviceListsQuery,
  getDeviceListsTabQuery,
  getDeviceSelectionTabQuery,
  getLoadedDeviceListsQuery,
  getSelectedDeviceListTab,
  setLoadedDeviceListsQuery,
  toPathWithQuery,
} from '../utils/deviceListTabsUtilsCoCo.js';

// Selected tab is kept in the URL, so that the tab can be linked to (e.g. from breadcrumbs) and survives reloads
export const useDeviceListTabsCoCo = () => {
  const navigate = useNavigate();
  const { pathname, search, hash } = useLocation();
  const selectedTab = getSelectedDeviceListTab(new URLSearchParams(search).get(DEVICE_LIST_TAB_PARAM));

  useEffect(() => {
    // Device lists data loaded on another tab or page doesn't necessarily match the Device lists tab query
    setLoadedDeviceListsQuery(undefined);
  }, []);

  useEffect(() => {
    if (selectedTab === DeviceListTabCoCo.DEVICE_LISTS) {
      setLoadedDeviceListsQuery(getDeviceListsQuery(search));
    }
  }, [selectedTab, search]);

  const selectTab = (tab: DeviceListTabCoCo) => {
    if (tab === selectedTab) {
      return;
    }
    const query =
      tab === DeviceListTabCoCo.DEVICE_LISTS
        ? getDeviceListsTabQuery(search, getLoadedDeviceListsQuery())
        : getDeviceSelectionTabQuery(search);
    navigate(toPathWithQuery(pathname, query, hash), { replace: true });
  };

  return { selectedTab, selectTab };
};
